import { createStore } from 'vuex'

export default createStore({
    state: {
        // 初期データ
        user_id: null,
        is_root: null,
        is_master_manager: null,
        is_debug: null,
        app_name: null,
    },
    mutations : {
        setUserId(state, id) {state.user_id = id;},
        setIsRoot(state, is_root) {state.is_root = is_root;},
        setIsMasterManager(state, is_master_manager) {state.is_master_manager = is_master_manager;},
        setIsDebug(state, is_debug) {state.is_debug = is_debug;},
        setAppName(state, app_name) {state.app_name = app_name}
    },
    getters: {
        userId(state) { return state.user_id; },
        isRoot(state) { return state.isRoot; },
        isMasterManager(state) { return state.isMasterManager; },
        isDebug(state) { return state.isDebug; },
        appName(state) {return state.app_name;},
    }
});
